import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import Loading from './Loading';

interface RouteGuardProps {
  children: React.ReactNode;
}

const RouteGuard: React.FC<RouteGuardProps> = ({ children }) => {
  const { user } = useAuthStore();
  const location = useLocation();

  // If no user in store, we could optionally verify with /me here.
  // For Phase 8, we rely on the store + axios interceptor for simplicity.
  if (user === undefined) {
    return <Loading />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default RouteGuard;
